// Links with custom text: [Text](https://example.com). Used in messages, embeds and profile bios.
export const MASKED_LINK_SOURCE='\\[[^\\[\\]\\n]{1,200}\\]\\(https?:\\/\\/[^\\s()<>]+(?:\\([^\\s()<>]*\\)[^\\s()<>]*)*\\)';
const FULL=new RegExp('^\\[([^\\[\\]\\n]{1,200})\\]\\((https?:\\/\\/\\S+)\\)$','i');
const INVISIBLE=/[\u0000-\u001f\u007f-\u009f­​-‏‪-‮⁠-⁩﻿]/g;
const DOMAIN=/(?:https?:\/\/|www\.)\S+|\b[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,}\b/i;
const host=(u:URL)=>u.hostname.toLowerCase().replace(/^www\./,'');

// A label that names another address would hide where the link really goes, so the real address is shown instead.
export function parseMaskedLink(part:string):{label:string;href:string}|null{
 const m=part.match(FULL);if(!m)return null;
 let url:URL;try{url=new URL(m[2]);}catch{return null;}
 if(!['http:','https:'].includes(url.protocol))return null;
 const label=m[1].replace(INVISIBLE,'').trim();if(!label)return null;
 const named=label.normalize('NFKC').match(DOMAIN)?.[0];
 if(named){let same=false;try{same=host(new URL(/^https?:\/\//i.test(named)?named:'https://'+named))===host(url);}catch{}if(!same)return {label:url.href,href:url.href};}
 return {label,href:url.href};
}
export const stripMaskedLinks=(text:string)=>text.replace(new RegExp(MASKED_LINK_SOURCE,'gi'),'');
// Runs a change only on the text outside masked links, so their addresses stay intact.
export const outsideMaskedLinks=(text:string,change:(part:string)=>string)=>text.split(new RegExp('('+MASKED_LINK_SOURCE+')','gi')).map((p,i)=>i%2?p:change(p)).join('');
